var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82498 6.72481C6.82498 6.33821 7.13838 6.02481 7.52498 6.02481L13.4647 6.02481C13.8513 6.02481 14.1647 6.33821 14.1647 6.72481L14.1647 12.6645C14.1647 13.0511 13.8513 13.3645 13.4647 13.3645C13.0781 13.3645 12.7647 13.0511 12.7647 12.6645L12.7647 8.41476L7.03001 14.1494C6.75664 14.4228 6.31342 14.4228 6.04006 14.1494C5.76669 13.8761 5.76669 13.4328 6.04006 13.1595L11.7747 7.42481L7.52498 7.42481C7.13838 7.42481 6.82498 7.11141 6.82498 6.72481Z",
    fill: "#C61E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/Arrowdown.1916a1da.svg";
export { ForwardRef as ReactComponent };